import { useCallback } from "react";
import { markAnswerStart } from "../../redux/questions/reducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  selectIsMarkingAnswer,
  selectMarkedAnswer,
} from "../../redux/questions/selectors";

function useMarkAnswer() {
  const dispatch = useDispatch();
  const markedQuestion = useSelector(selectMarkedAnswer);
  const isMarking = useSelector(selectIsMarkingAnswer);

  const markQuestion = useCallback(
    (data) => {
      dispatch(markAnswerStart(data));
    },
    [dispatch]
  );

  return {
    markQuestion,
    markedOptions: markedQuestion,
    isMarking,
  };
}

export default useMarkAnswer;
